import React from "react";
import Skeleton from "./Skeleton";
import styles from "../../style/about.module.css";
import skeletonStyles from "../../style/skeleton.module.css";

const AboutPageSkeleton = () => (
  <div
    className="container container-sm-fluid page-shell pb-4 pt-3 pt-md-5 skeleton-page"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading about page"
  >
    <div className="row g-4">
      <div
        className={`col-12 col-lg-auto pe-lg-4 ${styles.profileSticky} ${skeletonStyles.skeletonAboutProfile}`}
      >
        <Skeleton className={skeletonStyles.skeletonTitle} />
        <Skeleton className={skeletonStyles.skeletonAboutImage} />
      </div>
      <div className={`col-12 col-lg ${styles.aboutContentCol}`}>
        <div
          className={`${skeletonStyles.skeletonStack} ${skeletonStyles.skeletonStackLg}`}
        >
          <Skeleton className={skeletonStyles.skeletonSubtitle} />
          <Skeleton className={skeletonStyles.skeletonParagraph} />
          <Skeleton className={skeletonStyles.skeletonParagraph} />
          <Skeleton
            className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
          />
          <Skeleton className={skeletonStyles.skeletonParagraph} />
          <Skeleton
            className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
          />
        </div>
        <div
          className={`${skeletonStyles.skeletonStack} ${skeletonStyles.skeletonStackLg} mt-5`}
        >
          <Skeleton className={skeletonStyles.skeletonSubtitle} />
          <Skeleton className={skeletonStyles.skeletonParagraph} />
          <Skeleton
            className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
          />
        </div>
      </div>
    </div>
  </div>
);

export default AboutPageSkeleton;
